import { ReactNode } from 'react';
import { Col, Row } from 'reactstrap';
import { Group, Panel } from 'react-resizable-panels';
import { NSResizeHandle } from 'bricks';
import DealsMap from './components/DealsMap';
import DataPanel from './components/DataPanel';
import { Deal } from '../types';
import { useBatchGeocodedDeals } from '../hooks/useBatchGeocodedDeals';
import { DealColorLookup } from './hooks/useColoredDealIds';
import {
    DEFAULT_MAP_HEIGHT, MAP_MIN_HEIGHT, MAP_MAX_HEIGHT, DEALS_LIST_MIN_HEIGHT,
} from '../constants';
import './MapView.scss';

interface IMapViewProps {
    deals: Deal[];
    selectedDeal: Deal | null;
    hoveredDealId: number | null;
    colorByDealId?: DealColorLookup;
    children: ReactNode;
    onSelectDeal: (deal: Deal) => void;
    onDeselectDeal: () => void;
    onHoverDeal: (dealId: number | null) => void;
}

const MapView = ({
    deals,
    selectedDeal,
    hoveredDealId,
    colorByDealId,
    children,
    onSelectDeal,
    onDeselectDeal,
    onHoverDeal,
}: IMapViewProps) => {
    const geocodedCoordinates = useBatchGeocodedDeals(deals);

    return (
        <Group orientation="vertical" className="MapView__group">
            <Panel defaultSize={DEFAULT_MAP_HEIGHT} minSize={MAP_MIN_HEIGHT} maxSize={MAP_MAX_HEIGHT}>
                <Row noGutters className="MapView pt-2 h-100">
                    <Col xs={selectedDeal ? 8 : 12} className="d-block p-0">
                        <DealsMap
                            deals={deals}
                            geocodedCoordinates={geocodedCoordinates}
                            selectedDealId={selectedDeal?.id ?? null}
                            hoveredDealId={hoveredDealId}
                            colorByDealId={colorByDealId}
                            onSelectDeal={onSelectDeal}
                            onDeselectDeal={onDeselectDeal}
                            onHoverDeal={onHoverDeal}
                        />
                    </Col>
                    {selectedDeal && (
                        <Col xs={4} className="MapView__panel-col p-0">
                            <DataPanel detail={selectedDeal} onClose={onDeselectDeal} />
                        </Col>
                    )}
                </Row>
            </Panel>
            <NSResizeHandle orientation="horizontal" />
            <Panel minSize={DEALS_LIST_MIN_HEIGHT} className="overflow-auto">
                {children}
            </Panel>
        </Group>
    );
};

export default MapView;
